import type { StepConfig } from "@portal/components/multiform/types";
import type { BondRequestCreateFormData } from "../../schema";
import { BondStep } from "./BondStep";
import { BondSummary } from "./BondSummary";

export const bondStepConfig: StepConfig<BondRequestCreateFormData> = {
	name: "bond",
	label: "Bond",
	fieldPaths: ["quote"],
	component: BondStep,
	summaryComponent: BondSummary,
};
